const tableTitleEquip = {
  title: 'Tipos de Equipamentos',
  placeholder: 'Pesquisar'
}

export default tableTitleEquip;
